import ContainedButton from "components/layout/form/containedButton";
import styled from "styled-components";

export const Field = styled.div`
  width: 100%;
  min-height: 78px;

  @media (max-height: 762px) {
    min-height: 62px;
  }
`;

export const Button = styled(ContainedButton)`
  background-color: ${({ theme }) => theme.colors.blue};
  width: 100%;

  &:hover {
    opacity: 0.85;
  }

  span {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.white};
    font-weight: 500;
  }
`;

export const ContainerImgForm = styled.div`
  max-width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  margin-left: 4px;
`;

export const ImgForm = styled.img``;
